import { getAdditionalUserInfo, UserCredential } from "firebase/auth";

import { getUserLinkedProviders } from "services/firebase/auth/ssoProvider";

import extractUserDetails from "./extractUserDetails";

export default function extractUserDetailsWithLinkedProviders({
  authInfo,
  firebaseUserInfo = getAdditionalUserInfo(authInfo)
}: {
  authInfo: UserCredential;
  firebaseUserInfo?: ReturnType<typeof getAdditionalUserInfo>;
}) {
  return {
    ...extractUserDetails({
      authInfo,
      userProfile: (firebaseUserInfo as any).profile
    }),
    providerData: getUserLinkedProviders()
  };
}
